import React, { Fragment, lazy, Suspense, useState } from 'react';

import { defineMessages, useIntl } from 'react-intl';

import Checkbox from '@atlaskit/checkbox';

const AkFeedbackCollector = lazy(() =>
	import(
		/* webpackChunkName: "@atlaskit-internal_@atlassian/product-search-dialog/feedback-collector" */ '@atlaskit/feedback-collector'
	).then((module) => {
		return {
			default: module.default,
		};
	}),
);

const FEEDBACK_ENTRYPOINT_ID_BOOKMARKS = 'f32dde59-8eb1-4974-8839-20183d163480';
const FEEDBACK_CONTEXT_CF = 'customfield_10047';

const messages = defineMessages({
	bookmark_feedback_consent_checkbox_label: {
		id: 'search_ai.bookmark_feedback_consent_checkbox_label',
		defaultMessage: 'Include my last prompt and response in the feedback.',
		description:
			'Label for the checkbox asking for user consent to include their bookmark prompt and response in their feedback',
	},
});

type FeedbackModalProps = {
	setShowFeedbackModal: (showFeedbackModal: boolean) => void;
	setShowDisplayFlag: (showDisplayFlag: boolean) => void;
	query: string;
	url: string;
	userDetails?: {
		name?: string;
		id?: string;
	};
};

export const BookmarkFeedbackModal = ({
	setShowFeedbackModal,
	setShowDisplayFlag,
	query,
	url,
	userDetails,
}: FeedbackModalProps): React.JSX.Element => {
	const { formatMessage, locale } = useIntl();

	const [hasConsent, setConsent] = useState(false);

	const feedbackContextObject = {
		searchTerm: query,
		bookmarkUrl: url,
	};
	const feedbackContext = Object.entries(feedbackContextObject)
		.map(([key, value]) => `${key}: ${value}`)
		.join(', ');

	return (
		<Fragment>
			<Suspense fallback={<></>}>
				<AkFeedbackCollector
					locale={locale}
					onClose={() => setShowFeedbackModal(false)}
					onSubmit={() => {
						setShowDisplayFlag(true);
					}}
					atlassianAccountId={userDetails?.id}
					name={userDetails?.name}
					customContent={
						<Checkbox
							label={formatMessage(messages.bookmark_feedback_consent_checkbox_label)}
							onChange={() => setConsent(!hasConsent)}
							isChecked={hasConsent}
						/>
					}
					entrypointId={FEEDBACK_ENTRYPOINT_ID_BOOKMARKS}
					showTypeField={false}
					additionalFields={[
						{
							id: FEEDBACK_CONTEXT_CF,
							value: feedbackContext,
						},
					]}
				/>
			</Suspense>
		</Fragment>
	);
};
